export function normalizeWorkspaceDiagnostics(item) {
  return {
    workspace_id: String(item?.workspace_id || ""),
    repo_path: String(item?.repo_path || ""),
    authoring_root_path: String(item?.authoring_root_path || ""),
    fetch_auth_ref: String(item?.fetch_auth_ref || ""),
    push_auth_ref: String(item?.push_auth_ref || ""),
    review_auth_ref: String(item?.review_auth_ref || "")
  };
}

export function normalizeThreadDiagnostics(item) {
  return {
    mode: String(item?.mode || "harness"),
    thread_id: String(item?.thread_id || ""),
    worktree_path: String(item?.worktree_path || ""),
    provider_session_id: String(item?.provider_session_id || ""),
    provider_thread_id: String(item?.provider_thread_id || ""),
    last_request_id: String(item?.last_request_id || "")
  };
}

export function normalizeTurnDiagnostics(item) {
  return {
    mode: String(item?.mode || "harness"),
    turn_id: String(item?.turn_id || ""),
    worktree_path: String(item?.worktree_path || ""),
    managed_harness_log_path: String(item?.managed_harness_log_path || ""),
    request_log_id: String(item?.request_log_id || ""),
    model: String(item?.model || ""),
    route_id: String(item?.route_id || ""),
    usage_input_tokens: Number(item?.usage_input_tokens || 0),
    usage_output_tokens: Number(item?.usage_output_tokens || 0),
    usage_total_tokens: Number(item?.usage_total_tokens || 0),
    stream: {
      phase: String(item?.stream?.phase || ""),
      connected_at: item?.stream?.connected_at || "",
      request_posted_at: item?.stream?.request_posted_at || "",
      request_kind: String(item?.stream?.request_kind || ""),
      first_provider_event_at: item?.stream?.first_provider_event_at || "",
      last_provider_event_at: item?.stream?.last_provider_event_at || "",
      terminal_state: String(item?.stream?.terminal_state || ""),
      terminal_state_at: item?.stream?.terminal_state_at || "",
      watchdog_triggered_at: item?.stream?.watchdog_triggered_at || "",
      closed_before_completion_at: item?.stream?.closed_before_completion_at || "",
      failure_phase: String(item?.stream?.failure_phase || "")
    },
    provider_trace: {
      retained: Boolean(item?.provider_trace?.retained),
      retention_reason: String(item?.provider_trace?.retention_reason || ""),
      event_count: Number(item?.provider_trace?.event_count || 0)
    }
  };
}
